import { ArrowRight, Repeat } from 'lucide-react';

// The other direction: a patient with insurance on file who wants a membership
// instead. Deliberately a prompt rather than the plan grid — they have already
// made a choice, so this offers to reopen it rather than pitching over the top.
const SwitchToMembership = ({ onExplore }) => (
  <div className="animate-slide-up flex flex-col gap-4 rounded-xl border border-gray-200 bg-secondary-50/60 p-4 sm:flex-row sm:items-center">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-blue-100 bg-white text-teamcare-blue">
      <Repeat size={20} />
    </span>

    <div className="min-w-0 flex-1">
      <p className="text-[15px] font-bold text-secondary-900">Would a membership suit you better?</p>
      <p className="mt-1 text-xs leading-relaxed text-secondary-500">
        No waiting periods, no annual maximum, and member pricing on everything. It replaces
        your insurance rather than topping it up — joining takes your current plan off file.
      </p>
    </div>

    <button
      type="button"
      onClick={onExplore}
      className="btn h-11 min-h-11 shrink-0 gap-2 rounded-xl border border-secondary-200 bg-white px-4 text-sm font-semibold text-secondary-900 hover:border-secondary-300 hover:bg-secondary-50"
    >
      See the plans
      <ArrowRight size={15} />
    </button>
  </div>
);

export default SwitchToMembership;
